import { BasicFormWizardContext, FormValues, GlobalContextType } from 'types';
import { LogError } from 'utils/logging/LogError';
import derivePreSelections, { getUpdatedValues } from './derivePreSelections';

export function getDerivedFormValue(
  userData: GlobalContextType['userData'],
  taxonomyValues: GlobalContextType['taxonomyValues'],
  allQuestionsInForm: BasicFormWizardContext['allQuestionsInForm'],
  microSiteTaxonomyMap: GlobalContextType['microSiteTaxonomyMap']
): FormValues {
  if (!taxonomyValues || Object.keys(taxonomyValues).length === 0) {
    return {};
  }

  try {
    // given the current page type and the user's selection figure out how the form wizard should update
    const derivedFormValue = derivePreSelections({
      userData,
      taxonomyValues,
      allQuestionsInForm,
    });

    // If there should be changes process them
    if (derivedFormValue.length) {
      const updatedValues = getUpdatedValues(
        derivedFormValue,
        allQuestionsInForm,
        microSiteTaxonomyMap
      );

      return updatedValues.reduce((acc, { updatedValue, fieldName }) => {
        acc[fieldName] = updatedValue;
        return acc;
      }, {} as FormValues);
    }
  } catch (error) {
    LogError(
      `getDerivedFormValue failed due to ${
        error instanceof Error ? error.message : 'unknown error'
      }`
    );
  }

  return {};
}
